import CardWeather from "../card-weather/CardWeather";

import { useDragScroll } from "@/hooks/use-draggableScroll";
import { IDailyForecastData } from "@/types/daily-forecast-type";

import "./style.scss";

interface IDataExtend extends IDailyForecastData {
	dayWeek: string;
	day: string;
}

type CardListProps = {
	data: IDataExtend[];
	selectedDate: Date;
	type: "marine" | "world" | "weather";
};

export const CardList = ({ data, selectedDate, type }: CardListProps) => {
	const scrollRef = useDragScroll("x");

	return (
		<div className="card-list" ref={scrollRef}>
			{data.map((item, index) => (
				<CardWeather
					key={index}
					data={item}
					selectedDate={selectedDate}
					type={type}
				/>
			))}
		</div>
	);
};

export default CardList;
